import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as en from '../locales/en/translation.json';

// Create a separate i18n instance for shared-ui to avoid conflicts with app instances
const sharedUiI18n = i18n.createInstance();
const resources = {
    en: {
        translation: en,
    },
};

sharedUiI18n.use(initReactI18next).init({
    resources,
    fallbackLng: 'en',
    lng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export { sharedUiI18n };
